export default {
  "type": "object",
  "properties": {
    "0": {
      "type": "boolean"
    }
  },
  "required": ["0"]
};